/**
 * Triggers a direct browser file download for the given content.
 *
 * @param content The text/string content of the file.
 * @param contentType The MIME type of the file (e.g., 'text/csv').
 * @param fileName The name of the file to save as (e.g., 'export.csv').
 * @returns boolean indicating whether the download was successfully initiated.
 */
export function downloadFile(
  content: string,
  contentType: string,
  fileName: string
): boolean {
  try {
    const blob = new Blob([content], { type: contentType })
    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = fileName

    // Ensure the link is hidden and append to body
    a.style.display = 'none'
    document.body.appendChild(a)

    a.click()

    // Clean up
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    return true
  } catch (error) {
    console.error('Failed to trigger file download:', error)
    return false
  }
}
